/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_OceaniaInputs */

const bn_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওশেনিয়া`)
};

const de_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ozeanien`)
};

const el_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ωκεανία`)
};

const en_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const es_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanía`)
};

const fr_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Océanie`)
};

const hi_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओशिनिया`)
};

const hu_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óceánia`)
};

const id_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const it_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const ja_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オセアニア`)
};

const ko_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오세아니아`)
};

const nl_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanië`)
};

const pl_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const pt_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceânia`)
};

const ru_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океания`)
};

const sv_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanien`)
};

const tr_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okyanusya`)
};

const uk_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океанія`)
};

const vi_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu Đại Dương`)
};

const zh_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大洋洲`)
};

const zh_hant_geo_label_oceania = /** @type {(inputs: Geo_Label_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大洋洲`)
};

/**
* | output |
* | --- |
* | "Oceania" |
*
* @param {Geo_Label_OceaniaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_oceania = /** @type {((inputs?: Geo_Label_OceaniaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_OceaniaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_oceania(inputs)
	if (locale === "de") return de_geo_label_oceania(inputs)
	if (locale === "el") return el_geo_label_oceania(inputs)
	if (locale === "en") return en_geo_label_oceania(inputs)
	if (locale === "es") return es_geo_label_oceania(inputs)
	if (locale === "fr") return fr_geo_label_oceania(inputs)
	if (locale === "hi") return hi_geo_label_oceania(inputs)
	if (locale === "hu") return hu_geo_label_oceania(inputs)
	if (locale === "id") return id_geo_label_oceania(inputs)
	if (locale === "it") return it_geo_label_oceania(inputs)
	if (locale === "ja") return ja_geo_label_oceania(inputs)
	if (locale === "ko") return ko_geo_label_oceania(inputs)
	if (locale === "nl") return nl_geo_label_oceania(inputs)
	if (locale === "pl") return pl_geo_label_oceania(inputs)
	if (locale === "pt") return pt_geo_label_oceania(inputs)
	if (locale === "ru") return ru_geo_label_oceania(inputs)
	if (locale === "sv") return sv_geo_label_oceania(inputs)
	if (locale === "tr") return tr_geo_label_oceania(inputs)
	if (locale === "uk") return uk_geo_label_oceania(inputs)
	if (locale === "vi") return vi_geo_label_oceania(inputs)
	if (locale === "zh") return zh_geo_label_oceania(inputs)
	return zh_hant_geo_label_oceania(inputs)
});